// Third-party Library
import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux";
import {
    GoogleMap,
    useJsApiLoader
} from '@react-google-maps/api';

// Config
import { APP_CONFIG } from "../../config";

// Components
import VehicleMarkers from "./components/VehicleMarkers";
import InfoCard from "./components/InfoCard";
import gpsfleet_logo from './components/assets/gpsfleet-logo.svg'
// import shl_logo from './components/assets/shl-logo.png'

// Handlers
import { MapInitialiserWithVehicle } from "./components/MapInitialiserWithVehicle";

// Services library
// import { TIME } from "../../../v3/services/util";
import { wsContainer } from "../../../v3/services/websocket";

// Redux Actions
import * as REDUX_ACTIONS from '../../../v3/services/redux/actions'

// Styles
import styles from './index.module.css'
import ExpiredLinkPage from "./components/ExpiredLinkPage";
import SSOLoadingPanel from "../SSOLoading/components/SSOLoadingPanel";

const LiveTrackingMap = ({
    trackid,
}) => {

    const dispatch = useDispatch()

    const vehicles = useSelector(state => state.containers.v3.vehicles)

    const [mapRef, setMapRef] = useState(null)
    // const [isExpired, setIsExpired] = useState(false)

    const isInit = useRef(false)
    const [param, setParam] = useState({})
    const { plate, status } = param

    const vehicleStatics = Object.values(vehicles.staticsByID).find(v => v.plate === plate)
    const vid = vehicleStatics?.vid
    const vehicleState = vid ? { ...vehicleStatics, ...vehicles.stateByID[vid] } : null
    const { address, location } = vehicleState || {}

    // Initialization
    useEffect(() => {
        if(!isInit.current) {
            REDUX_ACTIONS.v3_locationTracking.get_tracking_link_by_trackid(trackid, (data) => {
                dispatch(REDUX_ACTIONS.v3_vehicles.get_vehicle_state_by_plate_request(data.plate, trackid))
                setParam(data)
            })
            isInit.current = true
        }
    }, [])

    // get address
    useEffect(() => {
        if (!location || !vid) return

        const intv = !address ? 1000 : 30000
        const timeout = setTimeout(() => {
            dispatch(REDUX_ACTIONS.v3_vehicles.get_vehicle_address_request(location, vid))
        }, intv)
        
        return () => clearTimeout(timeout)
    }, [location, vid, address])

    // Websocket
    useEffect(() => {

        wsContainer(
            (err, data) => {

                // console.log('wsco', data, err)

                if(!err) {
                    const {
                        id: refID,
                        mode,
                        item
                    } = data

                    switch(mode) {
                        case 'vhc': {
                            const vid = refID
        
                            vid && dispatch(REDUX_ACTIONS.v3_vehicles.update_vehicle_info_thru_ws_request(vid, item))

                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }
                
            },
            () => {
                // resubscribe
            },
            trackid
        )

    }, [])

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: APP_CONFIG.APP_GOOGLE_MAP_API_KEY,
        libraries: ['drawing']
    })

    MapInitialiserWithVehicle(location, mapRef)

    const isExpired = (status !== undefined) && status !== 1

    return (
        <>
            <div className={styles['header-container']}>
                <img src={gpsfleet_logo} style={{ height: 'inherit' }} alt=""/>
            </div>
            {
                isExpired === true
                ?
                <ExpiredLinkPage />
                :
                (isLoaded && isInit.current && Object.keys(param).length && location)
                &&
                <GoogleMap
                    id='googles-map'
                    mapContainerStyle={{
                        height: '100vh'
                    }}
                    onLoad={ref => setMapRef(ref)}
                >
                    <InfoCard vehicle={{ ...vehicleState, plate }}/>
                    <VehicleMarkers vid={vid} mapRef={mapRef} />
                </GoogleMap>
                ||
                 <SSOLoadingPanel />
            }
        </>
    )
}

export default React.memo(LiveTrackingMap)